// extracted by mini-css-extract-plugin
module.exports =  {"root":"_bMrGLSw7_ldW9aroLSg","primary":"oNklO7Ko2NdUWnrWWgLb _bMrGLSw7_ldW9aroLSg","secondary":"RnSKopUj0pwery32jt94 _bMrGLSw7_ldW9aroLSg","label":"SBrmp2L8JLhK31URwBHe"};